import { ErrorHandler } from '@angular/core';
import { environment } from '../../environments/environment';

type SentrySdk = typeof import('./sentry-sdk');
let sdk: SentrySdk | undefined;
let loading: Promise<void> | undefined;
let consentAllowed = false;
let sdkErrorHandler: ErrorHandler | undefined;

function canLoad(): boolean {
  return (
    typeof window !== 'undefined' &&
    environment.sentry.enabled &&
    !!environment.sentry.dsn
  );
}

export function initSentry(): void {
  if (!consentAllowed || !canLoad() || loading || sdk) return;
  loading = import('./sentry-sdk')
    .then((loaded) => {
      sdk = loaded;
      // Revocation or entry into a private route may happen during download.
      sdk.setSentryConsent(consentAllowed);
      if (consentAllowed) sdkErrorHandler = sdk.createAppErrorHandler();
    })
    .catch(() => {
      // Optional telemetry must never prevent the application from starting.
      loading = undefined;
    });
}

export function setSentryConsent(allowed: boolean): void {
  consentAllowed = allowed && canLoad();
  sdk?.setSentryConsent(consentAllowed);
  if (consentAllowed) {
    if (sdk && !sdkErrorHandler) sdkErrorHandler = sdk.createAppErrorHandler();
    initSentry();
  }
}

class ConsentAwareErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    if (consentAllowed && sdkErrorHandler) sdkErrorHandler.handleError(error);
    else super.handleError(error);
  }
}

export function createAppErrorHandler(): ErrorHandler {
  // Synchronous Angular bootstrap stays independent of the optional SDK.
  return new ConsentAwareErrorHandler();
}
